import { render } from "./CoachingView.vue?vue&type=template&id=17e4d1cc"
import script from "./CoachingView.vue?vue&type=script&lang=js"
export * from "./CoachingView.vue?vue&type=script&lang=js"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__